module.exports = __webpack_public_path__ + "img/1135222875.4f93e792.jpg";